module.exports = __webpack_public_path__ + "static/assets/a7692dce7e166d2c321352fdb8dff1f2.png";